import { render, staticRenderFns } from "./HomeCompanyResultCard.vue?vue&type=template&id=222c90b4&"
import script from "./HomeCompanyResultCard.vue?vue&type=script&lang=js&"
export * from "./HomeCompanyResultCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeCompanyResultCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports